import request from '@/utils/request'

// 蓝牙充电器数据分页
export function chargerPage(params) {
  return request({
    url: 'v3/manager/chargerRelation/page',
    method: 'post',
    data: params
  })
}
// 蓝牙充电器数据分页--新
export function findBluetoothDeviceList2(params) {
  return request({
    url: 'v3/report/findBluetoothDeviceList2',
    method: 'post',
    data: params
  })
}
// 全部公司
export function allCompanyList(param) {
  return request({
    url: '/v3/user/company/allCompanyList',
    method: 'get'
  })
}
// 下拉框--归属公司
export function listByCompanyParentId(params) {
  return request({
    url: 'v3/user/company/listByCompanyParentId',
    method: 'post',
    data: params
  })
}
// 蓝牙充电器日志/最后更新信息
export function pageBluetoothDetail(params) {
  return request({
    url: 'v3/report/pageBluetoothDetail',
    method: 'post',
    data: params
  })
}
// 蓝牙充电器日志/最后更新信息
export function pageBluetoothData(params) {
  return request({
    url: 'v3/report/pageBluetoothData',
    method: 'post',
    data: params
  })
}
// 锂电池列表（从蓝牙数据表的type=13,14,15的数据里group出来）
export function queryLiBatteryInfo(params) {
  return request({
    url: 'v3/report/queryLiBatteryInfo',
    method: 'post',
    data: params
  })
}
// kisae列表（从蓝牙数据表的type=10,11,12的数据里group出来）
export function queryKisaeInfo(params) {
  return request({
    url: 'v3/report/queryKisaeInfo',
    method: 'post',
    data: params
  })
}

// 蓝牙抄表数据
export function listBluetoothDetail(params) {
  return request({
    url: 'v3/report/listBluetoothDetail',
    method: 'post',
    data: params
  })
}
// 曲线更新数据分页
export function chargerCurveConfig(params) {
  return request({
    url: 'v3/manager/chargerCurveConfig/page',
    method: 'post',
    data: params
  })
}
// 版本管理分页
export function chargerFirmwareVersionConfig(params) {
  return request({
    url: 'v3/manager/chargerFirmwareVersionConfig/page',
    method: 'post',
    data: params
  })
}
// 所有版本
export function pageDeviceSystemVersionList(params) {
  return request({
    url: 'v3/manager/deviceSystemVersion/pageDeviceSystemVersionList',
    method: 'post',
    data: params
  })
}
// 时间校准分页
export function pageDeviceEventLog(params) {
  return request({
    url: 'v3/report/pageDeviceEventLog',
    method: 'post',
    data: params
  })
}
// 蓝牙充电器版本升级通知分页
export function chargerFirmwareVersionNotify(params) {
  return request({
    url: 'v3/manager/deviceFirmwareVersionNotify/page',
    method: 'post',
    data: params
  })
}
// 蓝牙充电器版本升级通知--新增
export function add(params) {
  return request({
    url: 'v3/manager/deviceFirmwareVersionNotify/add',
    method: 'post',
    data: params
  })
}
// 蓝牙充电器版本升级通知--编辑
export function update(params) {
  return request({
    url: 'v3/manager/deviceFirmwareVersionNotify/update',
    method: 'post',
    data: params
  })
}
// 蓝牙充电器版本升级通知--删除
export function deleteNotify(params) {
  return request({
    url: 'v3/manager/deviceFirmwareVersionNotify/delete',
    method: 'post',
    data: params
  })
}
// 蓝牙数据分页--yhub
export function findBluetoothDeviceList(params) {
  return request({
    url: 'v3/report/findBluetoothDeviceList',
    method: 'post',
    data: params
  })
}
